module.exports = __webpack_public_path__ + "static/media/argentina.1b145e05.svg";